import { AppConstant, VALIDATOR_PATTERNS } from "src/app/helper/class/app-constant";
import { mapInfoView } from "src/app/helper/interface/form-interface";
import { formBuilderData, tableColum } from "src/app/helper/interface/response";

export const PATIENT_LIST: formBuilderData[] = [
    {
        title: 'Patient Id',
        colName: 'patient_id',
        col_size: 4,
        readonly: true,
        validator: [{ name: 'required' }]
    },
    {
        colName: 'title_fk_id',
        title: 'Title',
        type: 'select',
        apiTblName: 'title',
        selectKeyName: 'titleName',
        selectPrimaryKey: 'id',
        defaultValue: '1',
        col_size: 4,
        validator: [{ name: 'required', error: 'Title should not be blank' }],
        visible: false
    },
    {
        title: 'Name',
        colName: 'f_name', col_size: 4,
        validator: [{ name: 'required', error: '' },],
    },
    {
        title: 'Last Name',
        colName: 'l_name', col_size: 4,
        visible: false
    },
    {
        title: 'Age',
        colName: 'age', col_size: 4,
        event: { name: 'change', isCallback: true },
        validator: [{ name: 'required' }, { name: 'pattern', funValue: VALIDATOR_PATTERNS.WHOLE_NUMBER }],
    },
    {
        title: 'Date Of Birth',
        colName: 'dob',
        col_size: 4,
        type: 'DATE',
        visible: false,
        event: { name: 'change', isCallback: true },
        defaultValue: ''
    },
    {
        title: 'Blood Group',
        colName: 'blood_group_fk_id',
        col_size: 4,
        type: 'select',
        apiTblName: 'blood_group',
        selectKeyName: "blood_groupName",
    },
    {
        colName: 'gender_fk_id',
        title: 'Gender',
        validator: [{ name: 'required' }],
        type: "select",
        data: AppConstant.GENDER,
        selectKeyName: "genderName",
        col_size: 4,
        visible: false
    },
    {
        title: 'Mobile No',
        colName: 'mobile_no',
        col_size: 4,
        event: { name: 'change', isCallback: true },
        validator: [{ name: 'required', error: '' }, { name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }],
    },
    {
        title: 'Alternative Mobile No',
        colName: 'alter_mobile_no',
        col_size: 4,
        event: { name: 'change', isCallback: true },
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }],
    },
    {
        title: 'State',
        colName: 'state_fk_id', col_size: 4,
        type: 'select',
        apiTblName: 'state',
        selectKeyName: 'stateName', selectPrimaryKey: 'id',
        validator: [{ name: 'required', error: '' },],
        defaultValue: '1',
        visible: false
    },
    {
        title: 'City',
        colName: 'city', col_size: 4,
        type: 'AUTOCOMPLETE',
        apiTblName: 'city',
        selectKeyName: 'cityName',
        apiFunName: 'search',
        forceSelection: false,
        selectPrimaryKey: 'id',
        visible: false,
    },
    // {
    //     title: 'Email',
    //     colName: 'email_id',
    //     col_size: 6,
    //     visible: false
    // },
    // {
    //     colName: 'patient_category_fk_id',
    //     title: 'Category',
    //     selectKeyName: 'patient_categoryName',
    //     apiTblName: 'patient_category',
    //     type: 'select',
    //     defaultValue: 1
    // },
    {
        title: 'Address',
        colName: 'address', type: "TEXTAREA",
        visible: false,
        col_size: 4
    },
    {
        title: 'Chief Complaints',
        colName: 'chief_complaint',
        col_size: 4,
        visible: false
    },
    {
        title: 'Created Date',
        colName: 'created_date', col_size: 4,
        type: 'DATE',
        visible: false,
        // hidden: true
        maxDate: new Date(),
    },
    {
        colName: 'medical_history_fk_id',
        title: 'Medical History',
        type: 'select',
        isEditableDropdown: true,
        selectionMode: 'multiple',
        selectKeyName: 'illnessName',
        selectPrimaryKey: 'id',
        apiTblName: 'illness',
        col_size: 4,
        event: { name: 'change', isCallback: true }
    },
    {
        colName: 'doctor_fk_id',
        title: 'Doctor',
        type: 'select',
        apiTblName: 'doctor',
        selectKeyName: 'fname',
        selectPrimaryKey: 'user_id',
        event: { name: 'change', isCallback: true },
        visible: false,
        col_size: 4
    },
    {
        colName: 'allow_sms',
        title: 'Allow to sent SMS/WhatsApp ? ',
        data: [{ allow_smsName: 'Yes', id: 1 }],
        selectKeyName: 'allow_smsName',
        selectPrimaryKey: 'id',
        type: 'checkbox',
        col_size: 4
    },
    // {
    //     colName: 'make_token',
    //     title: 'Generate Token ? ',
    //     data: [{ genTokenName: 'Yes', id: 1 }],
    //     selectKeyName: 'genTokenName',
    //     selectPrimaryKey: 'id',
    //     type: 'checkbox',
    //     visible: false,
    //     event: { name: 'change', isCallback: true }
    // },
]

export const WHATSAPP_LIST: formBuilderData[] = [

    {
        colName: 'isMemberSpouse', title: 'SMS', type: 'checkbox', selectKeyName: 'name', selectPrimaryKey: 'id',
        event: { isCallback: true, name: 'change' },
        data: [{ name: ' Yes', id: 1 }],
        visible: false
    },
]

export const NEW_INVESTIGATION: formBuilderData[] = [
    {
        colName: 'temp',
        inputKeyFilter: 'int',
        title: 'Temperature',
        col_size: 3,
        validator: [{ name: 'required' }]
    },
    {
        colName: 'weight',
        title: 'Weight',
        col_size: 3,
        inputKeyFilter: 'int',
        validator: [{ name: 'required' }]
    },
    {
        colName: 'bp',
        title: 'Blood Pressure',
        inputKeyFilter: 'int',
        col_size: 3,
        validator: [{ name: 'required' }]
    },
    {
        colName: 'blood_sugar',
        title: 'Blood Sugar',
        inputKeyFilter: 'int',
        col_size: 3,
        validator: [{ name: 'required' }]
    },
    {
        colName: 'observation',
        title: 'Observation',
        type: 'TEXTAREA',
        validator: [{ name: 'required' }]
    },
    // {
    //     colName: 'created_byName',
    //     title: 'Doctor',
    //     hidden: true,
    // },
    // {
    //     colName: 'created_at',
    //     title: 'Date',
    //     type: 'DATE',
    //     colType: 'DATE',
    //     hidden: true,
    //     defaultValue: new Date()
    // },
]

export const NEW_INVESTIGATION_TABLE: formBuilderData[] = [
    {
        colName: 'temp',
        inputKeyFilter: 'int',
        title: 'Temperature',
        col_size: 3
    },
    {
        colName: 'weight',
        title: 'Weight',
        col_size: 3,
        inputKeyFilter: 'int'
    },
    {
        colName: 'bp',
        title: 'Blood Pressure',
        inputKeyFilter: 'int',
        col_size: 3
    },
    {
        colName: 'blood_sugar',
        title: 'Blood Sugar',
        inputKeyFilter: 'int',
        col_size: 3
    },
    {
        colName: 'observation',
        title: 'Observation',
        type: 'TEXTAREA'
    },
    {
        colName: 'visited_on',
        title: 'Visited On'
    }
]

export const DENTAL_TABLE_LIST: tableColum[] = [
    {
        colName: 'examinationName',
        title: 'Examination Name'
    },
    {
        colName: 'teethNumber',
        title: 'Tooth Number'
    },
    {
        colName: 'remarks',
        title: 'Notes'
    },
]

export const PRESCRIPTION_COL: formBuilderData[] = [
    // { colName: 'id', hidden: true, title: '',visible:false },
    {
        title: 'Medicine',
        colName: 'medicine_fk_id',
        type: 'AUTOCOMPLETE',
        apiTblName: 'medicine',
        selectKeyName: 'medicineName',
        apiFunName: 'search',
        forceSelection: false,
        selectPrimaryKey: 'id',
        autoSearch: {
            titleKey: 'medicineName',
            selectFieldKeys: ['medicineName', 'medicine_typeName']
        },
        validator: [{ name: 'required' }]
    },
    {
        title: 'Dosage',
        colName: 'medicine_dosage_fk_id',
        type: 'select',
        apiTblName: 'medicine_dosage',
        selectKeyName: 'medicine_dosageName',
        selectPrimaryKey: 'id',
        isEditableDropdown: true,
        validator: [{ name: 'required' }]
    },
    {
        title: 'Frequency',
        colName: 'medicine_frequency_fk_id',
        type: 'select',
        apiTblName: 'medicine_frequency',
        selectKeyName: 'medicine_frequencyName',
        selectPrimaryKey: 'id',
        isEditableDropdown: true
    },
    {
        title: 'Duration',
        colName: 'medicine_duration_fk_id',
        type: 'select',
        apiTblName: 'medicine_duration',
        selectKeyName: 'medicine_durationName',
        selectPrimaryKey: 'id',
        isEditableDropdown: true,
        validator: [{ name: 'required' }]
    },
    {
        colName: 'notes',
        title: 'Notes',
        type: 'TEXTAREA',
    }
]
export const WHATSAPP_SEND: formBuilderData[] = [
    {
        colName: 'mobile_no',
        title: 'To Mobile Number',
        col_size: 12,
        validator: [{ name: 'required', error: '' },],
    },
    {
        colName: 'message',
        title: 'Message',
        type: 'TEXTAREA',
        col_size: 12,
        validator: [{ name: 'required', error: '' },],
    },
]
export const Patient_Data_Search: formBuilderData[] = [
    {
        colName: 'patient_fk_id',
        title: '',
        type: 'AUTOCOMPLETE',
        apiTblName: 'patient',
        selectKeyName: 'f_name',
        col_size: 12,
        selectPrimaryKey: 'id',
        apiFunName: 'search',
        placeholder: 'Search Patient........',
        autoSearch: {
            titleKey: 'f_name',
            selectFieldKeys: ['patient_id', 'f_name'],
            separatorText: ' _',
        },
    },
];

export const PATIENT_DETAIL: mapInfoView[] = [{
    title: 'ID',
    name: 'patient_id'
},
{
    title: 'Gender',
    name: 'genderName'
},
{
    title: 'Age',
    name: 'age'
},
{
    name: 'mobile_no',
    title: 'Mobile No'
},
{
    name: 'alter_mobile_no',
    title: 'Alternative Mobile No'
},
{
    name: 'full_address',
    title: 'Address',
},
{
    name: 'blood_groupName',
    title: 'Blood Group'
}, {
    name: 'created_date',
    title: 'Created Date',
    type: 'DATE',
}
]
